import React from "react";
import { Radio } from "lucide-react";
import { StatusChip } from "@/components/app/primitives";

// Standard chip identifying a live-engagement surface (never used on demo content)
export const LiveBadge = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[10px] font-mono uppercase tracking-widest bg-[--ai-soft] text-[--ai] border border-white/10 ${className}`} data-testid="live-mode-badge">
    <Radio size={10} className="lane-live" /> Live engagement
  </span>
);

// Standard source identification: source owner, upload date, version, coverage
export const SourceTag = ({ file, className = "" }) => {
  if (!file) return null;
  const up = (file.upload_date || "").slice(0, 10);
  const cov = file.coverage_start && file.coverage_end ? `${file.coverage_start} → ${file.coverage_end}` : null;
  return (
    <span className={`inline-flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[10px] font-mono text-[--tx-3] ${className}`} data-testid="live-source-tag">
      <span className="text-[--tx-2]">{file.source_owner}</span>
      <span>· uploaded {up}</span>
      <span>· v{file.version}</span>
      {cov && <span>· {cov}</span>}
    </span>
  );
};

export const REVIEW_TONE = {
  received: "neutral", profiled: "ai", mapped: "ai", usable: "validated", partial: "risk", blocked: "danger",
};

export const QUALITY_TONE = {
  unassessed: "neutral", good: "validated", acceptable: "ai", issues: "risk", unusable: "danger",
};

export const REQUEST_TONE = { missing: "risk", partial: "ai", received: "validated" };

export const ReviewStateChip = ({ state }) => (
  <StatusChip tone={REVIEW_TONE[state] || "neutral"} className="capitalize">{state}</StatusChip>
);

export const ConfidenceRank = ({ rank }) => {
  const map = {
    evidence_backed: { tone: "validated", label: "Evidence-backed" },
    strong_hypothesis: { tone: "ai", label: "Strong hypothesis" },
    hypothesis: { tone: "risk", label: "Hypothesis" },
    data_missing: { tone: "danger", label: "Data missing" },
    provisional: { tone: "risk", label: "Provisional" },
  };
  const m = map[rank] || { tone: "neutral", label: rank };
  return <StatusChip tone={m.tone}>{m.label}</StatusChip>;
};

export const fmtInt = (v) => (v === null || v === undefined ? "—" : Math.round(v).toLocaleString());
export const fmtPct = (v, d = 1) => (v === null || v === undefined ? "—" : `${(v * 100).toFixed(d)}%`);
export const fmtPt = (v, d = 1) => (v === null || v === undefined ? "—" : `${v >= 0 ? "+" : ""}${(v * 100).toFixed(d)}pt`);
